import styled from '@emotion/styled'

export const NaverAuthResultPageWrap = styled.div``
